export const SHOW_ALERTR = 'SHOW_ALERTR';
export const HIDE_ALERTR = 'HIDE_ALERTR';
export const SHOW_LOADER ='SHOW_LOADER';
export const ADD_NONE ='ADD_NONE';
export const FETCH_NOTES ='FETCH_NOTES';
export const REMOVE_NOTE ='REMOVE_NOTE';